import React from "react";
import { message } from "antd";
const error = (errorMSG: string) => message.error(errorMSG);
const success = (successMSG: string) => message.success(successMSG);
export {
    error,
    success
}